import React from 'react';

/**
 * ModalFooter - Componente de pie de página con botones de navegación
 *
 * Props:
 * - onBack: Función callback para el botón "Atrás" (opcional)
 * - onContinue: Función callback para el botón "Continuar" (opcional)
 * - continueText: Texto del botón continuar (default: "Continuar")
 * - backText: Texto del botón atrás (default: "Atrás")
 * - showBack: Si mostrar el botón de atrás (default: true)
 * - isLoading: Si está cargando/procesando (default: false)
 * - disabled: Si deshabilitar los botones (default: false)
 * - isSubmit: Si el botón continuar es de tipo submit (default: false)
 * - className: Clases CSS adicionales (opcional)
 */
function ModalFooter({
  onBack,
  onContinue,
  continueText = 'Continuar',
  backText = 'Atrás',
  showBack = true,
  isLoading = false,
  disabled = false,
  isSubmit = false,
  className = ''
}) {
  return (
    <div className={`d-flex gap-3 mt-2 mx-auto ${className}`} style={{ maxWidth: '400px' }}>
      {showBack && onBack && (
        <button
          type="button"
          onClick={onBack}
          className="btn btn-outline-secondary flex-fill"
          disabled={isLoading}
        >
          {backText}
        </button>
      )}
      <button
        type={isSubmit ? 'submit' : 'button'}
        onClick={onContinue}
        className="btn btn-primary flex-fill"
        disabled={disabled || isLoading}
      >
        {isLoading ? 'Procesando...' : continueText}
      </button>
    </div>
  );
}

export default ModalFooter;
